export default __webpack_public_path__ + "static/media/PCI.7c51794e.png";